import getCsrfToken from "./csrf_token"
//dependency
const $ = window.jQuery

$(document).ajaxSend((event, xhr, settings) => {
  if(settings.type != "GET") {
    xhr.setRequestHeader("X-CSRF-Token", getCsrfToken())
  }
})

export default $.ajax
